import { createClient } from '@supabase/supabase-js';

// For Create React App, environment variables need to be prefixed with REACT_APP_
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Missing Supabase environment variables. Authentication features may not work properly.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);